import type { Point } from '@ardoq/math';

interface BloatReducerState {
  previousPoint: Point;
  currentPoint: Point;
  result: Point[];
}
/** bloat a convex polygon with no coincident vertices by the specified margin */
const bloat = (points: Point[], margin: number): Point[] =>
  points.length < 3
    ? points
    : points.reduce(
        (
          { previousPoint, currentPoint, result }: BloatReducerState,
          nextPoint
        ) => {
          const direction = [
            previousPoint[1] - nextPoint[1],
            nextPoint[0] - previousPoint[0],
          ];
          const scale = margin / Math.hypot(direction[0], direction[1]);

          result.push([
            currentPoint[0] + scale * direction[0],
            currentPoint[1] + scale * direction[1],
          ]);
          return {
            previousPoint: currentPoint,
            currentPoint: nextPoint,
            result,
          };
        },
        {
          previousPoint: points[points.length - 2],
          currentPoint: points[points.length - 1],
          result: [],
        }
      ).result;

export { bloat };
